import { makeStyles } from 'tss-react/mui';
import { EditableSectionRow } from '../../../EditableSection';
import { Typography } from '@mui/material';
import { InsuranceDataType } from '../Settings/types';
import { useL10n } from '@uplift/hooks';
import { CalendarDateService } from '@uplift/services';

export type AdminInsuranceTimestampRowProps = {
  insuranceData: InsuranceDataType;
};

export const AdminInsuranceTimestampRow: React.VFC<AdminInsuranceTimestampRowProps> = ({ insuranceData }) => {
  const { classes } = useStyles();
  const l10n = useL10n();

  const lastCreatedAt = insuranceData?.createdAt
    ? CalendarDateService.date(insuranceData.createdAt).tz(CalendarDateService.timezones.ET).format('M/D/YYYY, h:mm A ET')
    : '';

  return (
    <div>
      <EditableSectionRow
        label={l10n.accountSettings.insurance.lastUpdate}
        rowKey="lastUpdate"
        kind="custom"
        hideLabel
        className={classes.lastUpdateRow}
      >
        <Typography variant="overline" color="textSecondary">{lastCreatedAt} • Added by {insuranceData?.createdByFullName}</Typography>
      </EditableSectionRow>
    </div>
  );
};


const useStyles = makeStyles()((theme) => ({
  lastUpdateRow: {
    borderTop: `1px solid ${theme.palette.divider}`,
  }
}));
